export class ConditionalAttribute {
    Display: string;
    Value: string;
    AttributeValues: string[];
}
